<template lang="pug">
  .step
    h1 兄弟姉妹にお子様はいますか
    .button_area
      button(@click="button_yes_click") はい
      button(@click="button_no_click") いいえ
    .button_area
      BackButton
    .family_message 下に相続関係図が表示されます
</template>

<script lang="js">
import BackButton from '@/components/module/BackButton.vue';

export default {
  components: {
    BackButton,
  },
  methods: {
    button_yes_click() {
      this.$emit('append_nephew', false);
      this.$router.push('/brother_input');
    },
    button_no_click() {
      this.$router.push('/brother_input');
    },
  },
};
</script>

<style lang="sass" scoped>
@import "../../assets/sass/component/step_style"
</style>